export var InquiryStatusEnum = /*#__PURE__*/ function(InquiryStatusEnum) {
    InquiryStatusEnum["Created"] = "Created";
    InquiryStatusEnum["Pending"] = "Pending";
    InquiryStatusEnum["Completed"] = "Completed";
    InquiryStatusEnum["Failed"] = "Failed";
    InquiryStatusEnum["Expired"] = "Expired";
    InquiryStatusEnum["NeedsReview"] = "NeedsReview";
    InquiryStatusEnum["Approved"] = "Approved";
    InquiryStatusEnum["Declined"] = "Declined";
    InquiryStatusEnum["Errored"] = "Errored";
    return InquiryStatusEnum;
}({});
